import React, {useEffect, useRef, useState} from 'react'
import {Button} from './Button'
import {Logo} from './Logo'
import {appUrl, sectionHref, signupPageHref} from './constants'

const sections = [
  {id: 'features', label: 'Features'},
  {id: 'pricing', label: 'Pricing'},
  {id: 'faq', label: 'FAQ'},
]

function HeaderV2({homePath = '/'}) {
  const links = sections.map(section => ({
    href: sectionHref(homePath, section.id),
    label: section.label,
  }))
  const [open, setOpen] = useState(false)
  const menuBtnRef = useRef(null)
  const closeBtnRef = useRef(null)
  const wasOpen = useRef(false)

  useEffect(() => {
    if (open) {
      closeBtnRef.current && closeBtnRef.current.focus()
    } else if (wasOpen.current) {
      menuBtnRef.current && menuBtnRef.current.focus()
    }
    wasOpen.current = open
  }, [open])

  useEffect(() => {
    if (!open) return undefined
    document.body.style.overflow = 'hidden'
    const onKey = event => {
      if (event.key === 'Escape') setOpen(false)
    }
    window.addEventListener('keydown', onKey)
    return () => {
      if (window.location.hash !== '#signup-mod') document.body.style.overflow = ''
      window.removeEventListener('keydown', onKey)
    }
  }, [open])

  return (
    <>
      <header className="hlm-nav">
        <div className="hlm-container hlm-nav-row">
          <Logo homePath={homePath} onClick={() => setOpen(false)} />
          <nav className="hlm-links" aria-label="Primary navigation">
            {links.map(link => (
              <a key={link.href} href={link.href}>
                {link.label}
              </a>
            ))}
          </nav>
          <div className="hlm-actions">
            <a className="hlm-signin" href={`${appUrl}/auth/login`}>
              Sign in
            </a>
            <Button href={signupPageHref} size="sm">
              Start free
            </Button>
          </div>
          <button
            ref={menuBtnRef}
            className="hlm-menu-btn"
            aria-label="Open menu"
            aria-expanded={open}
            aria-controls="hlm-mobile-drawer"
            type="button"
            onClick={() => setOpen(true)}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" aria-hidden="true">
              <line x1="3" y1="6" x2="21" y2="6" />
              <line x1="3" y1="12" x2="21" y2="12" />
              <line x1="3" y1="18" x2="21" y2="18" />
            </svg>
          </button>
        </div>
      </header>

      <aside
        id="hlm-mobile-drawer"
        className={`hlm-mobile-drawer ${open ? 'is-open' : ''}`}
        role="dialog"
        aria-modal="true"
        aria-label="Mobile menu"
        aria-hidden={!open}>
        <div className="hlm-mobile-top">
          <Logo homePath={homePath} onClick={() => setOpen(false)} />
          <button ref={closeBtnRef} type="button" className="hlm-modal-close" aria-label="Close menu" onClick={() => setOpen(false)}>
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" aria-hidden="true">
              <line x1="6" y1="6" x2="18" y2="18" />
              <line x1="18" y1="6" x2="6" y2="18" />
            </svg>
          </button>
        </div>
        <nav className="hlm-mobile-nav">
          {links.map(link => (
            <a key={link.href} href={link.href} onClick={() => setOpen(false)}>
              {link.label}
            </a>
          ))}
        </nav>
        <div className="hlm-mobile-cta">
          <a className="hlm-mobile-signin" href={`${appUrl}/auth/login`} onClick={() => setOpen(false)}>
            Sign in
          </a>
          <Button href={signupPageHref} size="sm" full onClick={() => setOpen(false)}>
            Start free
          </Button>
        </div>
      </aside>
    </>
  )
}

export default HeaderV2
